<template>
    <transition name="popup">
        <div class="main_popup hiddren_el_btscroll" 
            :style="{background:'rgba(0,0,0,'+bgRgba+')'}" 
            v-show="popShow">
            <transition name="pop">
                <div class="pop_box" 
                    v-show="popShow">
                    <div class="pop_title" 
                        v-drag 
                        :style="titleStyle">
                        <span>{{title}}</span>
                        <span class="pop_box-titles" v-if="$attrs.titles">{{$attrs.titles}}</span>
                        <div v-if="showClose" class="pop_close el-icon-close" @click="closePop(false)"></div>
                    </div>
                    <div class="pop_content" :style="popStyle()">
                        <slot></slot>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    name:'vPopup',
    props:{
        value:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
        },
        bgRgba:{
            type:String,
            default:'0.5'
        },
        showClose:{
            type: Boolean,
            default: true,
        },
        width:String,
        height:String,
        titleStyle:{
            type:Object,
            default:function(){
                return {backgroundColor: '#0094ff', color: '#fff'}
            }
        },
        appendToBody:Boolean,
    },
    directives:{
        drag(el,building){
            let obj = el.parentNode;
            el.onmousedown = function(e){
                var divx = e.clientX - obj.offsetLeft;
                var divy = e.clientY - obj.offsetTop;
                document.onmousemove = function(e){
                    document.onselectstart = () => false;
                    var l = e.clientX - divx;
                    var t = e.clientY - divy;
                    obj.style.left=l+'px';
                    obj.style.top=t+'px';
                }
                document.onmouseup = function(e){
                    document.onselectstart = null;
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
            }
        }
    },
    data(){
        return {
            popShow:this.value || false,
            bodyOverflow: null,
        }
    },
    watch:{
        value:function(val){
            if(val){
                this.bodyOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            }else{
                document.body.style.overflow = this.bodyOverflow;
            }
            this.popShow = val
        },
        popShow:function(val){
            this.$emit('input',val);
        }
    },
    methods:{
        popStyle(){
            let width = this.width ? this.width : (window.innerWidth * .9 + 'px');
            let height = this.height ? this.height : (window.innerHeight * .8 + 'px');
            return { maxWidth: width , maxHeight: height }
        },
        closePop(boo){
            this.popShow = boo;
            this.$emit('close')
        },
        getZIdex(){
            let popSection = document.querySelector('section[role="popsection"]');
            if(!popSection) {
                popSection = document.createElement('section');
                popSection.style.zIndex = '-999';
                popSection.setAttribute('role', 'popsection');
                document.body.appendChild(popSection)
            }
            let popList = document.querySelectorAll('div[role="popup"]');
            let zIndex = 1000;
            if(popList.length) {
                for(let i = 0; i < popList.length; i++) {
                    let curZIndex = popList[i].style.zIndex;
                    curZIndex = curZIndex ? +curZIndex : curZIndex
                    zIndex =  (curZIndex && curZIndex < zIndex) ? curZIndex : zIndex;
                }
            }
            this.$el.style.zIndex = zIndex;
        }
    },
    mounted(){
        if(this.appendToBody) {
            this.$nextTick(() => {
                this.getZIdex()
                let box = document.querySelector('section[role="popsection"]');
                box.insertBefore(this.$el, box.children[0]);
            })
        }
    },

    destroyed(){
        let box = document.querySelector('section[role="popsection"]');
        if (this.appendToBody && this.$el && box) {
            box.removeChild(this.$el);
        }
    },
}
</script>

<style scoped>
.main_popup{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1111;
}
.popup-enter-active,.popup-leave-active{
    transition: opacity .3s;
    opacity: 1;
}
.popup-enter,.popup-leave-to{
    opacity: 0;
}
.pop_box{
    display: inline-block;
    margin: 0 auto;
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%,10%);
    background-color: #fff;
    min-width: 200px;
    border-radius: 4px;
}
.pop-enter-active,.pop-leave-active{
    transition: transform .3s ease, opacity .3s ease;
    opacity: 1;
}
.pop-enter,.pop-leave-to{
    opacity: 0;
    /* 上->下 */
    transform: translate(-50%,0%);
    /* 下->上 */
    /* transform: translate(-50%,20%); */
    /* 左->右 */
    /* transform: translate(-100%,10%); */
    /* 右->左 */
    /* transform: translate(-0%,10%); */
    /* 折叠 */
    /* transform: translate(-50%,10%) rotateX(90deg); */
}

.pop_title{
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #D8D8D8;
    cursor: move;
}
.pop_title>span{
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    font-size: 15px;
  font-weight: bold;
}
.pop_close{
    position: absolute;
    right: 10px;
    top: 8px;
    cursor: pointer;
    text-align: center;
    font-size: 28px;
}
.pop_content{
    box-sizing: border-box;
    padding: 5px 20px;
    overflow: auto;
}
span.pop_box-titles{
  font-size: 12px;
  color: #0f6ab4;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/popup1.vue